import type { Ref } from "react";
import { servedLang } from "../i18n";
import type { BookingCancellationPolicyDisplay } from "../features/profile/operations";

/**
 * THE CANCELLATION POLICY AS THE SERVER SENT IT, verbatim: on Review, and as
 * the code step's snapshot of what was agreed there (rc.10). The served
 * language goes on the server's words and only there (reviewer, 2026-10-14):
 * the agreement beside it is ours, in the page's language.
 */
export function PolicyCard({
  policy,
  testId,
  panel,
  cardRef,
}: {
  policy: BookingCancellationPolicyDisplay;
  testId: string;
  /** The code step's in-page disclosure: a named region its toggle controls. */
  panel?: { id: string; ref?: Ref<HTMLDivElement> };
  /** Review's card, which a "has changed" stop brings into view (rc.11 F2). */
  cardRef?: Ref<HTMLDivElement>;
}) {
  const lang = servedLang(policy.locale);
  return (
    <div
      ref={panel?.ref ?? cardRef}
      id={panel?.id}
      role={panel ? "region" : undefined}
      aria-label={panel ? policy.headline : undefined}
      className="b-card t-sunken"
      data-testid={testId}
    >
      <span className="b-label" lang={lang}>{policy.headline}</span>
      <p className="b-meta" data-testid={`${testId}-body`} lang={lang}>{policy.body}</p>
    </div>
  );
}
